import { Outlet } from 'react-router-dom';
import env from '../configs/env';

const EnvironmentRoute = () => {
    // 環境表示を行う場合にbodyにクラスを追加し、環境表示で必要な調整に利用
    if (env.ENV !== 'prd') {
        document.body.classList.add(`env-show`);
    }
    return (
        <>
            {env.ENV !== 'prd' && (
                <div style={{ height: '40px', backgroundColor: 'blue', color: '#fff', textAlign: 'center', fontSize: '30px' }}>
                    {env.ENV + '環境'}
                </div>
            )}
            <Outlet />
        </>
    );
};

export default EnvironmentRoute;
